module.exports = __webpack_public_path__ + "static/img/2.43f3279.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rarity/2.png
// module id = JgXH
// module chunks = 0